
<div class="em-block form-style" v-if="folder">
  <div v-if="this.viewMode" class="em-child">
    <h3>Menu Folder</h3>

    <h4>Folder Name</h4>
    <p>{{folder.name}}</p>

    <div class="cta">
      <button @click="edit" type="button" class="btn grey-to-blue block">
        <span class="icon pencil"></span>
        Edit
      </button>
    </div>
  </div>

  <div v-else class="em-child">
    <h3>Menu Folder</h3>

    <div>
      <label for="folder-name">Folder Name</label>
      <input v-model="tempFolder.name" type="text" id="folder-name">
    </div>

    <div class="cta">
      <button @click="cancel" type="button" class="btn red outline block">Cancel</button>
      <button @click="save" type="button" class="btn green block" :disabled="tempFolder.name.length < 1">Save</button>
    </div>
  </div>
</div>
